export default __webpack_public_path__ + "static/media/preview_banner.dda1e238713a713c4adcdedca640e9da.svg";